













import Vue from 'vue'

interface State {
  audio: HTMLAudioElement;
  src: string;
  isPlaying: boolean;
}

export default Vue.extend({
  name: 'SampleSound',

  props: {
    // 再生してもよいか
    canPlay: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  data (): State {
    return {
      audio: new Audio(),
      // TODO アレンジ曲は差し替え
      src: 'assets/sound/odakyu-pipo-arrange.mp3',
      isPlaying: false,
    }
  },

  mounted () {
    this.audio.src = this.src

    this.audio.addEventListener('ended', this.onEnded)

    // 画面非表示で止める
    document.addEventListener('visibilitychange', this.onVisibilityChanged)
  },

  beforeDestroy () {
    // 音は停止
    this.audio.pause()

    this.isPlaying = false
    this.audio.removeEventListener('ended', this.onEnded)
    document.removeEventListener('visibilitychange', this.onVisibilityChanged)
  },

  methods: {
    toggle () {
      this.isPlaying = !this.isPlaying
    },

    /**
     * 再生終了
     */
    onEnded () {
      this.isPlaying = false
    },

    /**
     * 画面の表示が切り替わった
     * @param e
     */
    onVisibilityChanged (e: Event) {
      const document = e.target as Document
      if (document.visibilityState === 'hidden') {
        this.isPlaying = false
      }
    },
  },

  watch: {
    isPlaying (val: boolean) {
      if (val) {
        if (this.canPlay) {
          this.audio.play()
        }
      } else {
        this.audio.pause()
      }
    },

    canPlay (val: boolean) {
      if (!val) {
        // 再生不可になったら停止
        this.isPlaying = false
      }
    },
  },
})
